"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[272],{

/***/ 49859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PagesContext": function() { return /* binding */ PagesContext; }
/* harmony export */ });
/* harmony import */ var providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);
/* harmony import */ var providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57083);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var providers_Session_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48717);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* eslint-disable react-hooks/exhaustive-deps */


 // import { enviarPageView } from 'hooks/useGCJAnalytics'




var PagesContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({});

var PagesProvider = function PagesProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var serverSideContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_1__.ServerSidePropsContext);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      articles = _useState[0],
      setArticles = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serverSideContext.domain),
      domain = _useState2[0],
      setDomain = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      pageData = _useState3[0],
      setPageData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      pageList = _useState4[0],
      setPageList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      pageListData = _useState5[0],
      setPageListData = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      pageLoading = _useState6[0],
      setPageLoading = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    type: '',
    departmentSlug: ''
  }),
      pageType = _useState7[0],
      setPageType = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serverSideContext.navigation),
      navigation = _useState8[0],
      setNavigation = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      siteData = _useState9[0],
      setSiteData = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      siteExtId = _useState10[0],
      setSiteExtId = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      siteList = _useState11[0],
      setSiteList = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      siteName = _useState12[0],
      setSiteName = _useState12[1];

  var sessionData = (0,providers_Session_utils__WEBPACK_IMPORTED_MODULE_5__/* .getSessionDataFromCookie */ .o9)();

  var loadArticle = function loadArticle() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.pageSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles(serverSideContext.article);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.pageSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadArticle]', e);
      setPageLoading(false);
    });
  };

  var loadDepartment = function loadDepartment() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.pageSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles([]);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.pageSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadDepartment]', e);
      setPageLoading(false);
    });
  };

  var loadHome = function loadHome() {
    setPageLoading(true);
    (0,providers_actions_loadByCid__WEBPACK_IMPORTED_MODULE_0__/* .loadByContentList */ ._p)(serverSideContext.siteSlots, sessionData).then(function (response) {
      setPageType(serverSideContext.pageType);
      setNavigation(serverSideContext.navigation);
      setArticles([]);
      setPageData(serverSideContext.page);
      setPageList(serverSideContext.siteSlots);
      setPageListData(response);
      setSiteData(serverSideContext.site);
      setSiteExtId(serverSideContext.site.extid);
      setSiteList(serverSideContext.siteSlots);
      setSiteName(serverSideContext.site.name);
      setPageLoading(false);
    })["catch"](function (e) {
      console.log('[Fetch error :: loadHome]', e);
      setPageLoading(false);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (serverSideContext.pageType.type === 'article') {
      loadArticle();
    } else if (serverSideContext.pageType.type === 'department') {
      loadDepartment(); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      // enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.page.id.replace('policy:', '') });
    } else if (serverSideContext.pageType.type === 'home') {
      loadHome(); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      //  enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.site?.id.replace('policy:', '') });
    }
  }, [router.asPath]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PagesContext.Provider, {
    value: {
      articles: articles,
      domain: domain,
      navigation: navigation,
      pageData: pageData,
      pageList: pageList,
      pageListData: pageListData,
      pageLoading: pageLoading,
      pageType: pageType,
      siteData: siteData,
      siteExtId: siteExtId,
      siteList: siteList,
      siteName: siteName
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PagesProvider);

/***/ }),

/***/ 2078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_p": function() { return /* binding */ loadByContentList; },
/* harmony export */   "v9": function() { return /* binding */ loadByCidFilter; }
/* harmony export */ });
/* unused harmony exports loadByCid, loadImageByContentList */
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12437);
/* harmony import */ var mobile_detect__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mobile_detect__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54887);
/* harmony import */ var _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41263);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34987);





 // Função para aplicar timeout

var timeout = function timeout(ms) {
  return new Promise(function (_, reject) {
    return setTimeout(function () {
      return reject(new Error("Timeout"));
    }, ms);
  });
}; // Função que faz a requisição com timeout, limitando o tempo total a 2 segundos


var fetchWithTimeout = /*#__PURE__*/function () {
  var _ref = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(url, payload, cid) {
    var maxRetries,
        timeoutMs,
        attempt,
        result,
        _ret,
        _args2 = arguments;

    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            maxRetries = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 3;
            timeoutMs = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 3000;
            attempt = 0;
            result = null;

          case 4:
            if (!(attempt < maxRetries)) {
              _context2.next = 20;
              break;
            }

            _context2.prev = 5;
            return _context2.delegateYield( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              var controller, signal, fetchTimeout, response;
              return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      controller = new AbortController();
                      signal = controller.signal;
                      fetchTimeout = setTimeout(function () {
                        controller.abort();
                      }, timeoutMs);
                      response = void 0;

                      if (!(payload.email === undefined || !payload.email)) {
                        _context.next = 10;
                        break;
                      }

                      _context.next = 7;
                      return fetch(url, {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        signal: signal
                      });

                    case 7:
                      response = _context.sent;
                      _context.next = 14;
                      break;

                    case 10:
                      if (cid.includes('1.')) {
                        _context.next = 14;
                        break;
                      }

                      _context.next = 13;
                      return fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(payload),
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        signal: signal
                      });

                    case 13:
                      response = _context.sent;

                    case 14:
                      clearTimeout(fetchTimeout);

                      if (response.ok) {
                        _context.next = 17;
                        break;
                      }

                      throw new Error("HTTP error! status: ".concat(response.status));

                    case 17:
                      _context.next = 19;
                      return response.json();

                    case 19:
                      result = _context.sent;
                      console.log("[DEBUG] Sucesso: ", result);

                      if (!result) {
                        _context.next = 23;
                        break;
                      }

                      return _context.abrupt("return", {
                        v: result
                      });

                    case 23:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })(), "t0", 7);

          case 7:
            _ret = _context2.t0;

            if (!(typeof _ret === "object")) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 10:
            _context2.next = 17;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t1 = _context2["catch"](5);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] Tentativa falhou: ", _context2.t1);
            console.log("[DEBUG] Tentativa para o id falhou: ", cid);
            console.log("[DEBUG] Tentativa falhou: ", _context2.t1);

          case 17:
            attempt++;
            _context2.next = 4;
            break;

          case 20:
            throw new Error("Failed to fetch after ".concat(maxRetries, " attempts"));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 12]]);
  }));

  return function fetchWithTimeout(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var handlePromiseResult = function handlePromiseResult(result) {
  var fulfilledSlots = [];
  result.forEach(function (res) {
    return res.status === "fulfilled" && res.value.forEach(function (content) {
      return fulfilledSlots.push(content);
    });
  });
  return fulfilledSlots;
};

var loadByContentList = /*#__PURE__*/function () {
  var _ref2 = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(data, session) {
    var absoluteUrl,
        contentKeys,
        contentList,
        promisesList,
        md,
        deviceType,
        payload,
        _i,
        _contentList,
        cid,
        fetchResult,
        fulfilledSlots,
        _args3 = arguments;

    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            absoluteUrl = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "";
            contentKeys = Object.keys(data);
            contentList = [];
            promisesList = [];
            md = new (mobile_detect__WEBPACK_IMPORTED_MODULE_1___default())(window.navigator.userAgent);
            deviceType = md.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) ? "MOBILE" : "DESKTOP";
            payload = {
              email: session === null || session === void 0 ? void 0 : session.emailUsuario,
              product: "CBNGO",
              deviceType: deviceType,
              sessionId: session === null || session === void 0 ? void 0 : session.id
            };
            contentKeys.forEach(function (key) {
              return data[key].forEach(function (cid) {
                return cid && contentList.push((0,_util__WEBPACK_IMPORTED_MODULE_4__/* .castContentIdString */ .np)(cid));
              });
            });

            for (_i = 0, _contentList = contentList; _i < _contentList.length; _i++) {
              cid = _contentList[_i];
              _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) postFetchApi: ", "".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload);
              promisesList.push(fetchWithTimeout("".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload, cid));
            }

            _context3.prev = 9;
            _context3.next = 12;
            return Promise.allSettled(promisesList);

          case 12:
            fetchResult = _context3.sent;
            fulfilledSlots = handlePromiseResult(fetchResult);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) fulfilledSlots: ", fulfilledSlots);
            return _context3.abrupt("return", fulfilledSlots);

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](9);
            _utils_debugTools__WEBPACK_IMPORTED_MODULE_3__/* .debugTools.log */ .C.log("[DEBUG] (loadByContentList) [Fetch error :: loadByContentList]: ", _context3.t0);
            return _context3.abrupt("return", []);

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[9, 18]]);
  }));

  return function loadByContentList(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var loadImageByContentList = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(contentList) {
    var promisesArray, data, promiseResult;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            promisesArray = contentList.map(function (image_url) {
              return image_url ? fetch(image_url) : null;
            }).filter(Boolean);
            data = [];
            _context4.next = 4;
            return Promise.allSettled(promisesArray);

          case 4:
            promiseResult = _context4.sent;
            promiseResult.forEach(function (item) {
              if (item.status === "fulfilled") {
                (item === null || item === void 0 ? void 0 : item.value) && data.push(item === null || item === void 0 ? void 0 : item.value);
              }
            });
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function loadImageByContentList(_x6) {
    return _ref3.apply(this, arguments);
  };
}())); // Função para carregar dados por CID de forma não bloqueante


var loadByCid = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid) {
    var absoluteUrl,
        session,
        device,
        payload,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            absoluteUrl = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : "";
            session = _args5.length > 2 ? _args5[2] : undefined;
            device = _args5.length > 3 ? _args5[3] : undefined;
            payload = {
              email: session === null || session === void 0 ? void 0 : session.emailUsuario,
              product: "CBNGO",
              deviceType: device,
              polopolyContent: {
                contentId: cid,
                accessLevel: session === null || session === void 0 ? void 0 : session.nivelAcesso
              },
              sessionId: session === null || session === void 0 ? void 0 : session.id
            };
            debugTools.log("[DEBUG] (loadByCid) postApiPaywall: ", "".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload);
            return _context5.abrupt("return", postApiPaywall("".concat(absoluteUrl, "/siteApi/contentId/").concat(cid), payload));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function loadByCid(_x7) {
    return _ref4.apply(this, arguments);
  };
}())); // Função para carregar filtros com callbacks, sem bloquear o fluxo


var loadByCidFilter = function loadByCidFilter(params, callback) {
  var parsedData = "".concat(query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].stringify */ .Z.stringify(params));
  var url = "/siteApi/filter/".concat(params.policyId, "?").concat(parsedData);
  (0,_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchApi */ .a8)(url).then(function (response) {
    return callback(response);
  })["catch"](function (e) {
    return console.log("[Fetch Error :: loadDataByCidFilter]: ", e);
  });
};



/***/ }),

/***/ 34987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ fetchApi; },
/* harmony export */   "np": function() { return /* binding */ castContentIdString; }
/* harmony export */ });
/* unused harmony exports postFetchApi, deleteApiPaywall, postApiPaywall, patchCreditsEarnedPaywall, postApi */
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);




var castContentIdString = function castContentIdString(contentId) {
  var replacements = [{
    from: "contentid/",
    to: ""
  }, {
    from: "policy:/",
    to: ""
  }, {
    from: "policy:",
    to: ""
  }];
  var contentIdString = contentId || "";
  replacements === null || replacements === void 0 ? void 0 : replacements.map(function (r) {
    contentIdString = contentIdString.replace(r.from, r.to);
  });
  return contentIdString;
};
var fetchApi = /*#__PURE__*/function () {
  var _ref = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
    var res;
    return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.json());

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log("e", _context.t0);
            return _context.abrupt("return", []);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchApi(_x) {
    return _ref.apply(this, arguments);
  };
}();
var postFetchApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload)
            });

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", res.json());

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.log("e", _context2.t0);
            return _context2.abrupt("return", []);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function postFetchApi(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}()));
var deleteApiPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios["delete"](url).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              return res;
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteApiPaywall(_x4) {
    return _ref3.apply(this, arguments);
  };
}()));
var postApiPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url, body) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.post(url, body, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function postApiPaywall(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}()));
var patchCreditsEarnedPaywall = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.patch(url, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function patchCreditsEarnedPaywall(_x7) {
    return _ref5.apply(this, arguments);
  };
}()));
var postApi = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, body) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.post(url, body, {
              headers: {
                "Content-Type": "application/json"
              },
              withCredentials: true
            }).then(function (res) {
              return res.data;
            })["catch"](function (err) {
              var res = get(err, "response.data", {});
              console.log("err", res);
              return res;
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function postApi(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}()));

/***/ })

}]);